/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EmailTemplateCreateRequest, EmailTemplateResponse, EmailTemplateUpdateRequest } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class EmailTemplateAdminController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags email-template-admin-controller
   * @name FindById
   * @summary Find an email template
   * @request GET:/api/admin/v1/email-template/{id}
   */
  findById = (id: number, params: RequestParams = {}) =>
    this.request<EmailTemplateResponse, any>({
      path: `/api/admin/v1/email-template/${id}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags email-template-admin-controller
   * @name Update
   * @summary Update an email template
   * @request PUT:/api/admin/v1/email-template/{id}
   */
  update = (id: number, data: EmailTemplateUpdateRequest, params: RequestParams = {}) =>
    this.request<EmailTemplateResponse, any>({
      path: `/api/admin/v1/email-template/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags email-template-admin-controller
   * @name Delete
   * @summary Delete an email template
   * @request DELETE:/api/admin/v1/email-template/{id}
   */
  delete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/admin/v1/email-template/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags email-template-admin-controller
   * @name FindAll
   * @summary Find all email templates
   * @request GET:/api/admin/v1/email-template
   */
  findAll = (params: RequestParams = {}) =>
    this.request<EmailTemplateResponse[], any>({
      path: `/api/admin/v1/email-template`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags email-template-admin-controller
   * @name Create
   * @summary Create an email template
   * @request POST:/api/admin/v1/email-template
   */
  create = (data: EmailTemplateCreateRequest, params: RequestParams = {}) =>
    this.request<EmailTemplateResponse, any>({
      path: `/api/admin/v1/email-template`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
